export function resolveLocale(language) {
  const locale = String(language || 'ko').toLowerCase().split('-')[0];
  return locale === 'en' ? 'en' : 'ko';
}

export function localize(language, values) {
  const locale = resolveLocale(language);
  return values?.[locale] ?? values?.ko ?? values?.en ?? '';
}
